module.exports = __webpack_public_path__ + "static/media/illustration-en.87871bdc.png";